(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bars = document.querySelectorAll('[data-announcement-bar]');

    bars.forEach((bar) => {
      const sectionId = bar.dataset.sectionId;
      const storageKey = `announcement-dismissed:${sectionId}`;
      const dismissible = bar.dataset.dismissible === 'true';
      const dismissDays = Number(bar.dataset.dismissDays || 7);
      const autoRotate = bar.dataset.autoRotate === 'true';
      const rotateInterval = Number(bar.dataset.rotateInterval || 5) * 1000;
      const items = Array.from(bar.querySelectorAll('[data-announcement-item]'));
      const prev = bar.querySelector('[data-announcement-prev]');
      const next = bar.querySelector('[data-announcement-next]');
      const dismiss = bar.querySelector('[data-announcement-dismiss]');
      let index = 0;
      let timer;

      const isDismissed = () => {
        if (!dismissible) return false;
        try {
          const raw = localStorage.getItem(storageKey);
          if (!raw) return false;
          const until = Number(raw);
          if (Number.isNaN(until) || Date.now() > until) {
            localStorage.removeItem(storageKey);
            return false;
          }
          return true;
        } catch (e) {
          return false;
        }
      };

      const showItem = (nextIndex) => {
        if (!items.length) return;
        index = (nextIndex + items.length) % items.length;
        items.forEach((item, i) => {
          const active = i === index;
          item.toggleAttribute('hidden', !active);
          item.classList.toggle('is-active', active);
        });
      };

      const stopRotate = () => {
        if (timer) window.clearInterval(timer);
      };

      const startRotate = () => {
        stopRotate();
        if (!autoRotate || items.length < 2) return;
        timer = window.setInterval(() => showItem(index + 1), rotateInterval);
      };

      if (isDismissed()) {
        bar.setAttribute('hidden', '');
        return;
      }

      bar.removeAttribute('hidden');
      showItem(0);
      startRotate();

      if (prev) {
        prev.addEventListener('click', () => {
          showItem(index - 1);
          startRotate();
        });
      }

      if (next) {
        next.addEventListener('click', () => {
          showItem(index + 1);
          startRotate();
        });
      }

      if (dismiss) {
        dismiss.addEventListener('click', () => {
          try {
            const until = Date.now() + dismissDays * 24 * 60 * 60 * 1000;
            localStorage.setItem(storageKey, String(until));
          } catch (e) {}
          stopRotate();
          bar.setAttribute('hidden', '');
        });
      }

      bar.addEventListener('mouseenter', stopRotate);
      bar.addEventListener('mouseleave', startRotate);
      bar.addEventListener('focusin', stopRotate);
      bar.addEventListener('focusout', startRotate);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-banner-slideshow]';
    const instances = new WeakMap();

    const prefersReducedMotion = () =>
      window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
      document.body.classList.contains('respect-reduced-motion');

    const destroy = (root) => {
      const instance = instances.get(root);
      if (!instance) return;
      instance.cleanup();
      instances.delete(root);
    };

    const init = (root) => {
      if (!(root instanceof Element)) return;
      if (!root.matches(SELECTOR)) return;

      destroy(root);

      const slides = Array.from(root.querySelectorAll('[data-banner-slide]'));
      if (slides.length < 2) return;

      const dots = Array.from(root.querySelectorAll('[data-banner-dot]'));
      const live = root.querySelector('[data-banner-live]');
      const isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);
      const reduceMotion = !isDesignMode && prefersReducedMotion();
      const interval = Math.max(3, Number(root.dataset.interval || 5)) * 1000;

      const isAutoplayOn = () => root.dataset.autoplay === 'true';

      const getTransitionStyle = () => {
        const style = root.dataset.transition || 'fade';
        root.classList.toggle('banner-slideshow--fade', style === 'fade');
        root.classList.toggle('banner-slideshow--slide', style === 'slide');
        return style;
      };

      const getTransitionMs = () => {
        const ms = Math.max(300, Number(root.dataset.transitionMs || 450));
        root.style.setProperty('--bss-transition-duration', `${ms}ms`);
        return ms;
      };

      getTransitionStyle();
      getTransitionMs();

      let index = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      if (index < 0) index = 0;
      let timer = null;
      let animTimer = null;
      let animating = false;

      const announce = (slide) => {
        if (!live || !slide) return;
        const heading = slide.querySelector('.banner-slideshow__heading');
        live.textContent = heading ? heading.textContent.trim() : '';
      };

      const stop = () => {
        if (timer) window.clearTimeout(timer);
        timer = null;
      };

      const schedule = () => {
        stop();
        if (!isAutoplayOn() || document.hidden) return;
        timer = window.setTimeout(() => {
          if (animating) {
            schedule();
            return;
          }
          show(index + 1, 1);
          schedule();
        }, interval);
      };

      const clearMotionClasses = (slide) => {
        slide.classList.remove('is-exit-prev', 'is-exit-next', 'is-enter-next', 'is-enter-prev');
      };

      const show = (nextIndex, direction = 1) => {
        if (animating) return false;

        const from = index;
        const to = ((nextIndex % slides.length) + slides.length) % slides.length;
        if (to === from) return false;

        let dir = direction;
        if (dir !== 1 && dir !== -1) {
          dir = to > from || (from === slides.length - 1 && to === 0) ? 1 : -1;
        }

        const transitionStyle = getTransitionStyle();
        const transitionMs = getTransitionMs();

        if (transitionStyle === 'slide' && !reduceMotion) {
          animating = true;
          const outgoing = slides[from];
          const incoming = slides[to];
          const exitClass = dir > 0 ? 'is-exit-prev' : 'is-exit-next';
          const enterClass = dir > 0 ? 'is-enter-next' : 'is-enter-prev';

          slides.forEach((slide, i) => {
            if (i === from || i === to) return;
            clearMotionClasses(slide);
            slide.classList.remove('is-active');
            slide.setAttribute('aria-hidden', 'true');
          });

          clearMotionClasses(incoming);
          incoming.classList.remove('is-active');
          incoming.classList.add(enterClass);
          incoming.setAttribute('aria-hidden', 'false');
          incoming.offsetWidth;

          clearMotionClasses(outgoing);
          outgoing.classList.remove('is-active');
          outgoing.classList.add(exitClass);
          outgoing.setAttribute('aria-hidden', 'true');

          incoming.classList.add('is-active');

          if (animTimer) window.clearTimeout(animTimer);
          animTimer = window.setTimeout(() => {
            clearMotionClasses(outgoing);
            clearMotionClasses(incoming);
            outgoing.classList.remove('is-active');
            incoming.classList.add('is-active');
            animating = false;
            animTimer = null;
          }, transitionMs + 40);
        } else {
          slides.forEach((slide, i) => {
            clearMotionClasses(slide);
            const active = i === to;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          });
        }

        index = to;
        dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        announce(slides[index]);
        return true;
      };

      const onDotClick = (event) => {
        const dot = event.currentTarget;
        const target = Number(dot.dataset.bannerDot || 0);
        const dir = target >= index ? 1 : -1;
        show(target, dir);
        schedule();
      };

      const onKeyDown = (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          show(index - 1, -1);
          schedule();
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          show(index + 1, 1);
          schedule();
        }
      };

      const onVisibility = () => {
        if (document.hidden) {
          stop();
          return;
        }
        schedule();
      };

      slides.forEach((slide, i) => {
        clearMotionClasses(slide);
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
        dot.addEventListener('click', onDotClick);
      });
      announce(slides[index]);

      root.addEventListener('keydown', onKeyDown);
      document.addEventListener('visibilitychange', onVisibility);

      schedule();

      instances.set(root, {
        cleanup: () => {
          stop();
          if (animTimer) window.clearTimeout(animTimer);
          dots.forEach((dot) => dot.removeEventListener('click', onDotClick));
          root.removeEventListener('keydown', onKeyDown);
          document.removeEventListener('visibilitychange', onVisibility);
        },
      });
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll(SELECTOR).forEach(init);
    };

    const findRoot = (target) => {
      if (!(target instanceof Element)) return null;
      if (target.matches(SELECTOR)) return target;
      return target.querySelector(SELECTOR);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = findRoot(event.target);
      if (root) init(root);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const root = findRoot(event.target);
      if (root) destroy(root);
    });

    document.addEventListener('shopify:section:select', (event) => {
      const root = findRoot(event.target);
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSearch = (root) => {
      const input = root.querySelector('[data-collection-list-search]');
      if (!input || root.dataset.searchReady === 'true') return;
      root.dataset.searchReady = 'true';

      const items = [...root.querySelectorAll('[data-collection-item]')];
      input.addEventListener('input', () => {
        const q = input.value.trim().toLocaleLowerCase('tr-TR');
        items.forEach((item) => {
          const card = item.querySelector('[data-collection-card]');
          const title = (card?.dataset.collectionTitle || '').toLocaleLowerCase('tr-TR');
          item.hidden = q !== '' && !title.includes(q);
        });
      });
    };

    const initAnimate = (root) => {
      if (!root.hasAttribute('data-collection-list-animate') || root.dataset.animateReady === 'true') return;
      root.dataset.animateReady = 'true';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        root.classList.add('is-visible');
        return;
      }
      if (!('IntersectionObserver' in window)) {
        root.classList.add('is-visible');
        return;
      }
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.15 }
      );
      observer.observe(root);
    };

    const boot = (scope = document) => {
      scope.querySelectorAll('[data-collection-list]').forEach((root) => {
        initSearch(root);
        initAnimate(root);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dual-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-dual-banner].dual-banner--motion-on';
    const observers = new WeakMap();

    const shouldReduceMotion = () =>
      window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
      document.body.classList.contains('respect-reduced-motion');

    const reveal = (section) => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          section.classList.add('is-inview');
        });
      });
    };

    const disconnect = (section) => {
      const observer = observers.get(section);
      if (!observer) return;
      observer.disconnect();
      observers.delete(section);
    };

    const initSection = (section) => {
      if (!(section instanceof Element)) return;
      if (!section.matches(SELECTOR)) return;

      disconnect(section);
      section.classList.remove('is-inview');

      if (shouldReduceMotion() || !('IntersectionObserver' in window)) {
        reveal(section);
        return;
      }

      const rect = section.getBoundingClientRect();
      const alreadyVisible = rect.top < window.innerHeight * 0.9 && rect.bottom > 0;
      if (alreadyVisible) {
        reveal(section);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            reveal(entry.target);
            observer.unobserve(entry.target);
            observers.delete(entry.target);
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -5% 0px' }
      );

      observers.set(section, observer);
      observer.observe(section);
    };

    const initAll = (root = document) => {
      root.querySelectorAll(SELECTOR).forEach(initSection);
    };

    initAll();

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target;
      if (!(root instanceof Element)) return;
      const section = root.matches(SELECTOR) ? root : root.querySelector(SELECTOR);
      if (section) initSection(section);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target;
      if (!(root instanceof Element)) return;
      const section = root.matches(SELECTOR) ? root : root.querySelector(SELECTOR);
      if (section) disconnect(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFaq = (root) => {
      if (!(root instanceof Element) || root.dataset.faqBound === 'true') return;
      if (!root.hasAttribute('data-faq-one-at-a-time')) return;

      root.dataset.faqBound = 'true';
      const items = root.querySelectorAll('.faq__item');

      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          items.forEach((other) => {
            if (other !== item && other.open) other.open = false;
          });
        });
      });
    };

    document.querySelectorAll('[data-faq]').forEach(initFaq);

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target;
      if (!(root instanceof Element)) return;
      const faq = root.matches('[data-faq]') ? root : root.querySelector('[data-faq]');
      if (faq) {
        delete faq.dataset.faqBound;
        initFaq(faq);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-featured-video]';

    const prefersReducedMotion = () =>
      window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
      document.body.classList.contains('respect-reduced-motion');

    const init = (root) => {
      if (!(root instanceof Element)) return;
      if (root.dataset.featuredVideoBound === 'true') return;

      const video = root.querySelector('video');
      if (!video) return;

      const replayBtn = root.querySelector('[data-featured-video-replay]');
      const isLoop = root.dataset.playbackMode === 'loop';

      root.dataset.featuredVideoBound = 'true';

      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.loop = isLoop;
      video.controls = false;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.removeAttribute('controls');
      if (isLoop) {
        video.setAttribute('loop', '');
      } else {
        video.removeAttribute('loop');
      }

      let hasEnded = false;

      const tryPlay = () => {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      };

      const showReplay = () => {
        if (isLoop || !replayBtn) return;
        root.classList.add('is-ended');
        replayBtn.hidden = false;
      };

      const hideReplay = () => {
        root.classList.remove('is-ended');
        if (replayBtn) replayBtn.hidden = true;
      };

      hideReplay();

      if (prefersReducedMotion()) {
        video.pause();
        video.removeAttribute('autoplay');
        if (!isLoop) {
          showReplay();
          hasEnded = true;
        }
        if (replayBtn) {
          replayBtn.addEventListener('click', () => {
            hasEnded = false;
            hideReplay();
            video.currentTime = 0;
            tryPlay();
          });
        }
        return;
      }

      if (!isLoop) {
        video.addEventListener('ended', () => {
          hasEnded = true;
          showReplay();
        });

        if (replayBtn) {
          replayBtn.addEventListener('click', () => {
            hasEnded = false;
            hideReplay();
            video.currentTime = 0;
            tryPlay();
          });
        }
      }

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                if (!hasEnded) tryPlay();
                return;
              }
              if (!hasEnded) video.pause();
            });
          },
          { threshold: 0.2 }
        );
        observer.observe(video);
      } else {
        tryPlay();
      }
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll(SELECTOR).forEach(init);
    };

    const findRoot = (target) => {
      if (!(target instanceof Element)) return null;
      if (target.matches(SELECTOR)) return target;
      return target.querySelector(SELECTOR);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = findRoot(event.target);
      if (!root) return;
      delete root.dataset.featuredVideoBound;
      init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFooterAccordion = (footer) => {
      if (!footer.hasAttribute('data-footer-accordion')) return;
      if (footer.dataset.accordionBound === 'true') return;
      footer.dataset.accordionBound = 'true';

      footer.querySelectorAll('.site-footer__column').forEach((column) => {
        const heading = column.querySelector(':scope > .site-footer__heading');
        if (!heading) return;

        const siblings = Array.from(column.children).filter((el) => el !== heading);
        if (!siblings.length) return;

        const wrapper = document.createElement('div');
        wrapper.className = 'site-footer__accordion-body';
        siblings.forEach((el) => wrapper.appendChild(el));
        column.appendChild(wrapper);
        wrapper.hidden = true;

        heading.classList.add('site-footer__accordion-toggle');
        heading.setAttribute('role', 'button');
        heading.setAttribute('tabindex', '0');
        heading.setAttribute('aria-expanded', 'false');

        const toggle = () => {
          const isOpen = heading.getAttribute('aria-expanded') === 'true';
          heading.setAttribute('aria-expanded', String(!isOpen));
          wrapper.hidden = isOpen;
        };

        heading.addEventListener('click', toggle);
        heading.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggle();
          }
        });
      });
    };

    document.querySelectorAll('[data-footer-accordion]').forEach(initFooterAccordion);

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target;
      if (!(root instanceof Element)) return;
      const footer = root.matches('[data-footer-accordion]')
        ? root
        : root.querySelector('[data-footer-accordion]');
      if (footer) initFooterAccordion(footer);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const SCROLL_THRESHOLD = 12;

    const initDrawer = (header) => {
      const openBtn = header.querySelector('[data-header-menu-open]');
      const closeBtn = header.querySelector('[data-header-menu-close]');
      const drawer = header.querySelector('[data-header-drawer]');
      if (!openBtn || !drawer || header.dataset.drawerBound === 'true') return;

      header.dataset.drawerBound = 'true';

      const setOpen = (open) => {
        drawer.toggleAttribute('hidden', !open);
        openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.classList.toggle('header-drawer-open', open);
        if (open) {
          const focusTarget = drawer.querySelector('[data-header-menu-close], a, button, input');
          if (focusTarget) focusTarget.focus();
        } else {
          openBtn.focus();
        }
      };

      openBtn.addEventListener('click', () => setOpen(true));
      if (closeBtn) closeBtn.addEventListener('click', () => setOpen(false));

      drawer.addEventListener('click', (event) => {
        if (event.target === drawer) setOpen(false);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !drawer.hasAttribute('hidden')) {
          setOpen(false);
        }
      });
    };

    const initSmartSticky = (header) => {
      if (!header.hasAttribute('data-smart-sticky')) return;
      if (header.dataset.smartStickyBound === 'true') return;
      header.dataset.smartStickyBound = 'true';

      let ticking = false;

      const update = () => {
        const scrolled = window.scrollY > SCROLL_THRESHOLD;
        header.classList.toggle('is-scrolled', scrolled);
        ticking = false;
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };

      update();
      window.addEventListener('scroll', onScroll, { passive: true });
    };

    const initHideOnScroll = (header) => {
      if (!header.hasAttribute('data-hide-on-scroll')) return;
      if (header.dataset.hideOnScrollBound === 'true') return;
      header.dataset.hideOnScrollBound = 'true';

      let lastY = window.scrollY;
      let ticking = false;

      const update = () => {
        const currentY = window.scrollY;
        if (currentY <= SCROLL_THRESHOLD) {
          header.classList.remove('is-hidden');
        } else if (currentY > lastY) {
          header.classList.add('is-hidden');
        } else if (currentY < lastY) {
          header.classList.remove('is-hidden');
        }
        lastY = currentY;
        ticking = false;
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };

      window.addEventListener('scroll', onScroll, { passive: true });
    };

    const initHeader = (header) => {
      if (!(header instanceof Element)) return;
      initDrawer(header);
      initSmartSticky(header);
      initHideOnScroll(header);
    };

    document.querySelectorAll('[data-site-header]').forEach(initHeader);

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target;
      if (!(root instanceof Element)) return;
      const header = root.matches('[data-site-header]')
        ? root
        : root.querySelector('[data-site-header]');
      if (header) {
        delete header.dataset.drawerBound;
        delete header.dataset.smartStickyBound;
        delete header.dataset.hideOnScrollBound;
        initHeader(header);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatWithDelimiters = (number, precision, thousands, decimal) => {
      const safePrecision = precision == null ? 2 : precision;
      const safeThousands = thousands || ',';
      const safeDecimal = decimal || '.';
      if (number == null || Number.isNaN(Number(number))) return '0';
      const fixed = (Number(number) / 100).toFixed(safePrecision);
      const parts = fixed.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${safeThousands}`);
      const cents = parts[1] ? `${safeDecimal}${parts[1]}` : '';
      return `${dollars}${cents}`;
    };

    const moneyFormat = (cents, { format, currency, locale } = {}) => {
      if (currency) {
        try {
          return new Intl.NumberFormat(locale || undefined, {
            style: 'currency',
            currency,
            currencyDisplay: 'symbol',
          }).format(Number(cents) / 100);
        } catch (error) {
          // Fall through to theme money format.
        }
      }

      const formatString = format || ('{' + '{amount}}');
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, formatString);
      }

      const placeholderMatch = formatString.match(/\{\{\s*(\w+)\s*\}\}/);
      const placeholder = placeholderMatch ? placeholderMatch[1] : 'amount';
      let value = '';

      switch (placeholder) {
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'", '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', ',');
          break;
        case 'amount_with_period_and_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', '.');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
          break;
      }

      return formatString.replace(/\{\{\s*\w+\s*\}\}/, value);
    };

    const desktopMq = window.matchMedia('(min-width: 1025px)');

    const initPhotoSwipe = (root, activate) => {
      const LightboxCtor = window.PhotoSwipeLightbox;
      const CoreCtor = window.PhotoSwipe;
      if (root._pswpLightbox || !LightboxCtor || !CoreCtor) return;

      const lightbox = new LightboxCtor({
        gallery: root,
        children: 'a[data-gallery-open]',
        pswpModule: CoreCtor,
        showHideAnimationType: 'zoom',
        bgOpacity: 0.92,
        wheelToZoom: true,
        paddingFn: (viewportSize) => {
          const pad = viewportSize.x < 641 ? 12 : 28;
          return { top: pad, bottom: pad, left: pad, right: pad };
        },
        closeTitle: root.dataset.pswpClose || 'Close',
        zoomTitle: root.dataset.pswpZoom || 'Zoom',
        arrowPrevTitle: root.dataset.pswpPrev || 'Previous',
        arrowNextTitle: root.dataset.pswpNext || 'Next'
      });

      lightbox.on('change', () => {
        const curr = lightbox.pswp?.currSlide?.data?.element;
        const mediaId = curr?.dataset?.mediaId;
        if (mediaId) activate(mediaId);
      });

      lightbox.init();
      root._pswpLightbox = lightbox;
    };

    const initGallery = (root) => {
      if (!root || root.dataset.galleryReady === 'true') return;
      root.dataset.galleryReady = 'true';

      const slides = [...root.querySelectorAll('[data-gallery-slide]')];
      const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];

      const activate = (mediaId) => {
        slides.forEach((slide) => {
          const active = String(slide.dataset.mediaId) === String(mediaId);
          slide.classList.toggle('is-active', active);
          slide.hidden = !active;
        });
        thumbs.forEach((thumb) => {
          const active = String(thumb.dataset.mediaId) === String(mediaId);
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => activate(thumb.dataset.mediaId));
      });

      let attempts = 0;
      const tryPhotoSwipe = () => {
        if (window.PhotoSwipeLightbox && window.PhotoSwipe) {
          initPhotoSwipe(root, activate);
          return;
        }
        if (attempts < 40) {
          attempts += 1;
          window.setTimeout(tryPhotoSwipe, 50);
        }
      };
      tryPhotoSwipe();

      root.selectMedia = activate;
    };

    const initStickyBar = (summaryRoot) => {
      const sectionId = summaryRoot.dataset.sectionId;
      const sticky =
        document.querySelector(`[data-product-sticky-bar][data-section-id="${sectionId}"]`) ||
        summaryRoot.parentElement?.querySelector('[data-product-sticky-bar]');
      if (!sticky || sticky.dataset.stickyReady === 'true') return;
      sticky.dataset.stickyReady = 'true';

      const sentinel = summaryRoot.querySelector('[data-product-cta-sentinel]');
      const stickyPrice = sticky.querySelector('[data-sticky-price]');
      const stickyAdd = sticky.querySelector('[data-sticky-add]');
      const form = summaryRoot.querySelector('form[data-ajax-cart], form[action*="/cart/add"]');
      const submitBtn = summaryRoot.querySelector('[data-product-submit]');
      let ctaVisible = true;

      const syncVisibility = () => {
        if (desktopMq.matches) {
          sticky.hidden = true;
          sticky.classList.remove('is-visible');
          return;
        }
        sticky.hidden = false;
        sticky.classList.toggle('is-visible', !ctaVisible);
      };

      if (sentinel && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            ctaVisible = Boolean(entries[0]?.isIntersecting);
            syncVisibility();
          },
          { threshold: 0.15, rootMargin: '0px' }
        );
        observer.observe(sentinel);
      } else {
        ctaVisible = false;
      }

      stickyAdd?.addEventListener('click', () => {
        if (!form || submitBtn?.disabled) return;
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      });

      summaryRoot._stickySync = ({ priceText, available, addLabel, soldOutLabel }) => {
        if (stickyPrice && priceText) stickyPrice.textContent = priceText;
        if (!stickyAdd) return;
        stickyAdd.disabled = !available;
        stickyAdd.textContent = available ? addLabel : soldOutLabel || addLabel;
      };

      const onMqChange = () => syncVisibility();
      if (typeof desktopMq.addEventListener === 'function') {
        desktopMq.addEventListener('change', onMqChange);
      } else if (typeof desktopMq.addListener === 'function') {
        desktopMq.addListener(onMqChange);
      }

      syncVisibility();
    };

    const initSummary = (root) => {
      if (!root || root.dataset.summaryReady === 'true') return;
      root.dataset.summaryReady = 'true';

      const jsonEl = root.querySelector('[data-product-json]');
      if (!jsonEl) return;
      let product;
      try {
        product = JSON.parse(jsonEl.textContent);
      } catch (error) {
        return;
      }

      const form = root.querySelector('form[data-ajax-cart], form[action*="/cart/add"]');
      const variantInput = root.querySelector('[data-product-variant-id]');
      const priceEl = root.querySelector('[data-price]');
      const compareEl = root.querySelector('[data-compare-price]');
      const stockValueEl = root.querySelector('[data-product-stock-value]');
      const submitBtn = root.querySelector('[data-product-submit]');
      const errorEl = root.querySelector('[data-variant-error]');
      const qtyInput = root.querySelector('[data-qty-input]');
      const optionInputs = [...root.querySelectorAll('[data-option-position]')];
      const soldOutLabel = submitBtn?.dataset.soldOutLabel;
      const addLabel = submitBtn?.dataset.addLabel || submitBtn?.textContent?.trim();
      const ctaMode = root.dataset.ctaMode || 'add_to_cart';
      const moneyFormatString = root.dataset.moneyFormat || ('{' + '{amount}}');
      const moneyCurrency = root.dataset.moneyCurrency || '';
      const moneyLocale = root.dataset.moneyLocale || document.documentElement.lang || 'tr';
      const formatPrice = (cents) =>
        moneyFormat(cents, {
          format: moneyFormatString,
          currency: moneyCurrency,
          locale: moneyLocale,
        });

      initStickyBar(root);

      const getSelections = () => {
        const selected = {};
        optionInputs.forEach((input) => {
          if (!input.checked) return;
          selected[Number(input.dataset.optionPosition)] = input.value;
        });
        return selected;
      };

      const findVariant = () => {
        if (!product.variants) return null;
        if (product.variants.length === 1) return product.variants[0];
        const selected = getSelections();
        return product.variants.find((variant) =>
          variant.options.every((value, index) => selected[index + 1] === value)
        );
      };

      const updateUI = () => {
        const variant = findVariant();
        if (!variant) {
          if (errorEl) errorEl.hidden = false;
          if (submitBtn) {
            submitBtn.disabled = true;
            if (soldOutLabel) submitBtn.textContent = soldOutLabel;
          }
          root._stickySync?.({
            available: false,
            addLabel,
            soldOutLabel,
          });
          return;
        }

        if (errorEl) errorEl.hidden = true;
        if (variantInput) variantInput.value = variant.id;
        const priceText = formatPrice(variant.price);
        if (priceEl) priceEl.textContent = priceText;
        if (stockValueEl) {
          stockValueEl.textContent = variant.available
            ? stockValueEl.dataset.inStockLabel || ''
            : stockValueEl.dataset.soldOutLabel || '';
        }
        if (compareEl) {
          if (variant.compare_at_price > variant.price) {
            compareEl.hidden = false;
            compareEl.textContent = formatPrice(variant.compare_at_price);
          } else {
            compareEl.hidden = true;
            compareEl.textContent = '';
          }
        }

        const canBuy = ctaMode === 'add_to_cart' && variant.available;
        if (submitBtn && ctaMode !== 'info') {
          submitBtn.disabled = !canBuy;
          submitBtn.textContent = canBuy ? addLabel : soldOutLabel || addLabel;
        }
        if (qtyInput && variant.inventory_management && variant.inventory_quantity > 0) {
          qtyInput.max = Math.min(99, variant.inventory_quantity);
        }

        root._stickySync?.({
          priceText,
          available: canBuy,
          addLabel,
          soldOutLabel,
        });

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);

        const gallery = document.querySelector('[data-product-gallery]');
        const mediaId = variant.featured_media?.id || variant.featured_image?.id;
        if (gallery && typeof gallery.selectMedia === 'function' && mediaId) {
          gallery.selectMedia(mediaId);
        }
      };

      optionInputs.forEach((input) => input.addEventListener('change', updateUI));

      root.querySelector('[data-qty-decrease]')?.addEventListener('click', () => {
        if (!qtyInput) return;
        qtyInput.value = String(Math.max(1, Number(qtyInput.value || 1) - 1));
      });
      root.querySelector('[data-qty-increase]')?.addEventListener('click', () => {
        if (!qtyInput) return;
        const max = Number(qtyInput.max || 99);
        qtyInput.value = String(Math.min(max, Number(qtyInput.value || 1) + 1));
      });

      form?.addEventListener('submit', () => {
        if (!submitBtn) return;
        submitBtn.setAttribute('aria-busy', 'true');
        window.setTimeout(() => submitBtn.removeAttribute('aria-busy'), 2500);
      });

      if (submitBtn && !submitBtn.dataset.addLabel) {
        submitBtn.dataset.addLabel = submitBtn.textContent.trim();
      }

      const termsInput = root.querySelector('[data-product-terms]');
      const buyNow = root.querySelector('[data-buy-now]');
      const syncTerms = () => {
        if (!buyNow || !buyNow.hasAttribute('data-requires-terms')) return;
        const ok = Boolean(termsInput?.checked);
        buyNow.classList.toggle('is-disabled', !ok);
      };
      termsInput?.addEventListener('change', syncTerms);
      syncTerms();

      const wishlistBtn = root.querySelector('[data-wishlist-toggle]');
      if (wishlistBtn) {
        const productId = String(wishlistBtn.dataset.productId || '');
        const storageKey = 'atlas-wishlist-ids';
        const readIds = () => {
          try {
            return JSON.parse(window.localStorage.getItem(storageKey) || '[]');
          } catch (error) {
            return [];
          }
        };
        const writeIds = (ids) => {
          window.localStorage.setItem(storageKey, JSON.stringify(ids));
        };
        const syncWishlist = () => {
          const active = readIds().map(String).includes(productId);
          wishlistBtn.setAttribute('aria-pressed', active ? 'true' : 'false');
        };
        wishlistBtn.addEventListener('click', () => {
          const ids = readIds().map(String);
          const index = ids.indexOf(productId);
          if (index >= 0) ids.splice(index, 1);
          else ids.push(productId);
          writeIds(ids);
          syncWishlist();
        });
        syncWishlist();
      }

      updateUI();
    };

    const initAtlasModals = (scope) => {
      scope.querySelectorAll('[data-atlas-modal-open]').forEach((trigger) => {
        if (trigger.dataset.modalBound === 'true') return;
        trigger.dataset.modalBound = 'true';

        trigger.addEventListener('click', () => {
          const targetId = trigger.getAttribute('data-atlas-modal-target');
          const dialog = targetId ? document.getElementById(targetId) : null;
          if (!dialog || typeof dialog.showModal !== 'function') return;
          dialog.showModal();
          const focusTarget = dialog.querySelector('[data-atlas-modal-close]');
          focusTarget?.focus();
        });
      });

      scope.querySelectorAll('[data-atlas-modal]').forEach((dialog) => {
        if (dialog.dataset.modalBound === 'true') return;
        dialog.dataset.modalBound = 'true';

        dialog.querySelectorAll('[data-atlas-modal-close]').forEach((closeBtn) => {
          closeBtn.addEventListener('click', () => dialog.close());
        });

        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
      });

      scope.querySelectorAll('[data-atlas-modal-auto-open-host]').forEach((host) => {
        const dialog = host.closest('[data-atlas-modal]');
        if (!dialog || typeof dialog.showModal !== 'function' || dialog.open) return;
        dialog.showModal();
      });
    };

    const boot = (scope = document) => {
      scope.querySelectorAll('[data-product-gallery]').forEach(initGallery);
      scope.querySelectorAll('[data-product-summary]').forEach(initSummary);
      initAtlasModals(scope);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('[data-product-tabs]');

    roots.forEach((root) => {
      const list = root.querySelector('[data-product-tabs-list]');
      const panels = Array.from(root.querySelectorAll('[data-product-tab-panel]'));
      if (!list || !panels.length) return;

      list.replaceChildren();

      if (panels.length === 1) {
        root.classList.remove('product-tabs--enabled');
        list.hidden = true;
        panels[0].classList.add('is-active');
        panels[0].removeAttribute('hidden');
        return;
      }

      root.classList.add('product-tabs--enabled');
      list.hidden = false;

      const tabs = panels.map((panel, index) => {
        const id = panel.getAttribute('data-product-tab-panel');
        const label = panel.getAttribute('data-tab-label') || `Tab ${index + 1}`;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'product-tabs__tab';
        button.id = `ProductTabBtn-${id}`;
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-controls', panel.id || `ProductTabPanel-${id}`);
        button.setAttribute('data-product-tab', id);
        button.textContent = label;
        if (!panel.id) panel.id = `ProductTabPanel-${id}`;
        panel.setAttribute('aria-labelledby', button.id);
        list.appendChild(button);
        return button;
      });

      const activate = (name, { focusTab = false, scrollTab = false } = {}) => {
        tabs.forEach((tab) => {
          const selected = tab.getAttribute('data-product-tab') === name;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          if (selected) {
            if (focusTab) tab.focus({ preventScroll: true });
            if (scrollTab && list.scrollWidth > list.clientWidth) {
              const tabRect = tab.getBoundingClientRect();
              const listRect = list.getBoundingClientRect();
              const left = list.scrollLeft + (tabRect.left - listRect.left) - (list.clientWidth - tabRect.width) / 2;
              list.scrollTo({ left, behavior: 'smooth' });
            }
          }
        });
        panels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.getAttribute('data-product-tab-panel') === name);
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab.getAttribute('data-product-tab'), { scrollTab: true }));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = null;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex === null) return;
          event.preventDefault();
          activate(tabs[nextIndex].getAttribute('data-product-tab'), { focusTab: true, scrollTab: true });
        });
      });

      activate(panels[0].getAttribute('data-product-tab-panel'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initViewToggle = (root) => {
      const buttons = [...root.querySelectorAll('[data-view]')];
      if (!buttons.length || root.dataset.viewReady === 'true') return;
      root.dataset.viewReady = 'true';

      buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const mode = btn.dataset.view;
          root.classList.remove('products-grid--view-grid', 'products-grid--view-list');
          root.classList.add(`products-grid--view-${mode}`);
          root.dataset.viewMode = mode;
          buttons.forEach((item) => {
            const active = item.dataset.view === mode;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        });
      });
    };

    const initLoadMore = (root) => {
      const button = root.querySelector('[data-products-grid-load-more]');
      const list = root.querySelector('[data-products-grid-list]');
      if (!button || !list || root.dataset.loadMoreReady === 'true') return;
      root.dataset.loadMoreReady = 'true';

      button.addEventListener('click', async () => {
        const nextUrl = button.dataset.nextUrl;
        if (!nextUrl) return;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        try {
          const url = new URL(nextUrl, window.location.origin);
          url.searchParams.set('sections', root.dataset.sectionId);
          const response = await fetch(`${url.pathname}${url.search}`);
          const data = await response.json();
          const html = data[root.dataset.sectionId];
          if (!html) return;
          const doc = document.createElement('div');
          doc.innerHTML = html;
          const nextRoot = doc.querySelector('[data-products-grid]');
          const nextItems = nextRoot?.querySelectorAll('[data-products-grid-list] > li') || [];
          nextItems.forEach((item) => list.appendChild(item));
          const nextBtn = nextRoot?.querySelector('[data-products-grid-load-more]');
          if (nextBtn?.dataset.nextUrl) {
            button.dataset.nextUrl = nextBtn.dataset.nextUrl;
            button.disabled = false;
            button.removeAttribute('aria-busy');
          } else {
            button.remove();
          }
        } catch (error) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
    };

    const initAnimate = (root) => {
      if (!root.hasAttribute('data-products-grid-animate') || root.dataset.animateReady === 'true') return;
      root.dataset.animateReady = 'true';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        root.classList.add('is-visible');
        return;
      }
      if (!('IntersectionObserver' in window)) {
        root.classList.add('is-visible');
        return;
      }
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12 }
      );
      observer.observe(root);
    };

    const boot = (scope = document) => {
      scope.querySelectorAll('[data-products-grid]').forEach((root) => {
        initViewToggle(root);
        initLoadMore(root);
        initAnimate(root);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (sectionRoot) => {
      const root = sectionRoot?.matches?.('[data-related-products]')
        ? sectionRoot
        : sectionRoot?.querySelector?.('[data-related-products]');
      if (!root || root.dataset.relatedReady === 'true') return;
      if (root.querySelector('.related-products__section')) {
        root.dataset.relatedReady = 'true';
        return;
      }

      const url = root.dataset.url;
      if (!url) return;
      root.dataset.relatedReady = 'true';

      const load = () => {
        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const next = html.querySelector('[data-related-products]');
            if (next && next.querySelector('.related-products__section')) {
              root.replaceWith(next);
            } else {
              root.remove();
            }
          })
          .catch(() => {
            root.remove();
          });
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            if (!entries[0]?.isIntersecting) return;
            observer.disconnect();
            load();
          },
          { rootMargin: '0px 0px 200px 0px' }
        );
        observer.observe(root);
      } else {
        load();
      }
    };

    const boot = () => {
      document.querySelectorAll('[data-related-products]').forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const initAnimate = (section) => {
      if (!section || section.dataset.textSectionReady === 'true') return;
      section.dataset.textSectionReady = 'true';

      if (reduceMotion) {
        section.classList.add('is-visible');
        return;
      }

      if (!('IntersectionObserver' in window)) {
        section.classList.add('is-visible');
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
      );

      observer.observe(section);
    };

    const boot = () => {
      document.querySelectorAll('[data-text-section-animate]').forEach(initAnimate);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-text-section-animate]');
      if (section) {
        section.dataset.textSectionReady = 'false';
        initAnimate(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
